import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';

export const selectEuDdp = (state: TStoreState) => state.euDdp;

export const selectDeliveryOperatorsSearch = (state: TStoreState) =>
	selectEuDdp(state).deliveryOperatorsSearch;

export const selectDeliveryOperatorsSearchLoading = (state: TStoreState) =>
	selectEuDdp(state).deliveryOperatorsSearchLoading;

const EMPTY_DELIVERY_OPERATORS: never[] = [];

export const selectDeliveryOperatorsSearchData = createSelector(
	[selectDeliveryOperatorsSearch],
	(result) => result?.data ?? EMPTY_DELIVERY_OPERATORS,
);

export const selectDeliveryOperatorsSearchTotal = (state: TStoreState) => {
	const data = selectDeliveryOperatorsSearch(state);
	return data?.totalCount ?? 0;
};

export const selectDeliveryOperatorsSearchPage = (state: TStoreState) => {
	const data = selectDeliveryOperatorsSearch(state);
	if (!data) return null;
	return { pageNumber: data.pageNumber, pageSize: data.pageSize };
};

export const selectCreateDeliveryOperatorLoading = (state: TStoreState) =>
	selectEuDdp(state).createDeliveryOperatorLoading;

export const selectCreateDeliveryOperatorSuccess = (state: TStoreState) =>
	selectEuDdp(state).createDeliveryOperatorSuccess;

export const selectUpdateDeliveryOperatorLoading = (state: TStoreState) =>
	selectEuDdp(state).updateDeliveryOperatorLoading;

export const selectUpdateDeliveryOperatorSuccess = (state: TStoreState) =>
	selectEuDdp(state).updateDeliveryOperatorSuccess;

export const selectTariffsSearch = (state: TStoreState) => selectEuDdp(state).tariffsSearch;

export const selectTariffsSearchLoading = (state: TStoreState) =>
	selectEuDdp(state).tariffsSearchLoading;

const EMPTY_TARIFFS: never[] = [];

export const selectTariffsSearchData = createSelector(
	[selectTariffsSearch],
	(result) => result?.data ?? EMPTY_TARIFFS,
);

export const selectTariffsSearchTotal = (state: TStoreState) => {
	const data = selectTariffsSearch(state);
	return data?.totalCount ?? 0;
};

export const selectTariffsSearchPage = (state: TStoreState) => {
	const data = selectTariffsSearch(state);
	if (!data) return null;
	return { pageNumber: data.pageNumber, pageSize: data.pageSize };
};

export const selectCreateTariffLoading = (state: TStoreState) =>
	selectEuDdp(state).createTariffLoading;

export const selectCreateTariffSuccess = (state: TStoreState) =>
	selectEuDdp(state).createTariffSuccess;

export const selectUpdateTariffLoading = (state: TStoreState) =>
	selectEuDdp(state).updateTariffLoading;

export const selectUpdateTariffSuccess = (state: TStoreState) =>
	selectEuDdp(state).updateTariffSuccess;

export const selectPricingPlansSearch = (state: TStoreState) =>
	selectEuDdp(state).pricingPlansSearch;

export const selectPricingPlansSearchLoading = (state: TStoreState) =>
	selectEuDdp(state).pricingPlansSearchLoading;

const EMPTY_PRICING_PLANS: never[] = [];

export const selectPricingPlansSearchData = createSelector(
	[selectPricingPlansSearch],
	(result) => result?.data ?? EMPTY_PRICING_PLANS,
);

export const selectPricingPlansSearchTotal = (state: TStoreState) => {
	const data = selectPricingPlansSearch(state);
	return data?.totalCount ?? 0;
};

export const selectPricingPlansSearchPage = (state: TStoreState) => {
	const data = selectPricingPlansSearch(state);
	if (!data) return null;
	return { pageNumber: data.pageNumber, pageSize: data.pageSize };
};

export const selectCreatePricingPlanLoading = (state: TStoreState) =>
	selectEuDdp(state).createPricingPlanLoading;

export const selectCreatePricingPlanSuccess = (state: TStoreState) =>
	selectEuDdp(state).createPricingPlanSuccess;

export const selectUpdatePricingPlanLoading = (state: TStoreState) =>
	selectEuDdp(state).updatePricingPlanLoading;

export const selectUpdatePricingPlanSuccess = (state: TStoreState) =>
	selectEuDdp(state).updatePricingPlanSuccess;

export const selectEuDdpRecordsSearch = (state: TStoreState) =>
	selectEuDdp(state).euDdpRecordsSearch;

export const selectEuDdpRecordsSearchLoading = (state: TStoreState) =>
	selectEuDdp(state).euDdpRecordsSearchLoading;

const EMPTY_EU_DDP_RECORDS: never[] = [];

export const selectEuDdpRecordsSearchData = createSelector(
	[selectEuDdpRecordsSearch],
	(result) => result?.data ?? EMPTY_EU_DDP_RECORDS,
);

export const selectOrdersSearch = (state: TStoreState) => selectEuDdp(state).ordersSearch;

export const selectOrdersSearchLoading = (state: TStoreState) =>
	selectEuDdp(state).ordersSearchLoading;

const EMPTY_ORDERS: never[] = [];

export const selectOrdersSearchData = createSelector(
	[selectOrdersSearch],
	(result) => result?.data ?? EMPTY_ORDERS,
);

export const selectOrdersSearchTotal = (state: TStoreState) => {
	const data = selectOrdersSearch(state);
	return data?.totalCount ?? 0;
};

export const selectOrdersSearchPage = (state: TStoreState) => {
	const data = selectOrdersSearch(state);
	if (!data) return null;
	return { pageNumber: data.pageNumber, pageSize: data.pageSize };
};

export const selectOrderDetails = (state: TStoreState) => selectEuDdp(state).orderDetails;

export const selectOrderDetailsLoading = (state: TStoreState) =>
	selectEuDdp(state).orderDetailsLoading;

export const selectPrintLabels = (state: TStoreState) => selectEuDdp(state).printLabels;

export const selectPrintLabelsLoading = (state: TStoreState) =>
	selectEuDdp(state).printLabelsLoading;

export const selectOmnivaLabelLoading = (state: TStoreState) =>
	selectEuDdp(state).omnivaLabelLoading;

export const selectInvoiceProformaLoading = (state: TStoreState) =>
	selectEuDdp(state).invoiceProformaLoading;
